import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import forms from './forms'

const namespaced = true

const defaultMeta =  {
  current_page: 1,
  desc: false,
  last_page: null,
  order: 'name',
  per_page: null,
  search: null,
  total: null
}

const _defaultView = 'all'
const _archivedView = 'archived'

const state = {
  current: null,
  _defaultView,
  _archivedView,
  views: {
    [_defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_archivedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: true,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/index.js